module.exports = __webpack_public_path__ + "img/templer.21d3ad63.png";